import React from "react"
import FieldProto_FormElement from "../../../../proto/render/form-element";
import DropdownFormStatelessView from "../../../../generic/dropdown/render/form/components/form-stateless";


export default class FieldProjectAccessMode_FormElement extends FieldProto_FormElement {

    render() {
        return <DropdownFormStatelessView className      = {this.props.className}
                                 field          = {this.props.field}
                                 value          = {this.value}
                                 model          = {this.props.model}
                                 configOptions  = {this.props.options}
                                 disabled       = {this.props.disabled}
                                 onChange       = {this.onChange}/>
    }

}